/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AccountCanHaveMoreConnectedTrialAccountsQueryVariables = GraphQL.Exact<{
  accountId: GraphQL.Scalars['AccountId']['input'];
}>;


export type AccountCanHaveMoreConnectedTrialAccountsQuery = { readonly __typename?: 'Query', readonly account: { readonly __typename?: 'Account', readonly canHaveMoreConnectedTrialAccounts: boolean, readonly id: CK.AccountId } | null };


export const AccountCanHaveMoreConnectedTrialAccountsDocument = gql`
    query AccountCanHaveMoreConnectedTrialAccounts($accountId: AccountId!) {
  account(id: $accountId) {
    canHaveMoreConnectedTrialAccounts
    id
  }
}
    `;

/**
 * __useAccountCanHaveMoreConnectedTrialAccountsQuery__
 *
 * To run a query within a React component, call `useAccountCanHaveMoreConnectedTrialAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountCanHaveMoreConnectedTrialAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountCanHaveMoreConnectedTrialAccountsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAccountCanHaveMoreConnectedTrialAccountsQuery(baseOptions: Apollo.QueryHookOptions<AccountCanHaveMoreConnectedTrialAccountsQuery, AccountCanHaveMoreConnectedTrialAccountsQueryVariables> & ({ variables: AccountCanHaveMoreConnectedTrialAccountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountCanHaveMoreConnectedTrialAccountsQuery, AccountCanHaveMoreConnectedTrialAccountsQueryVariables>(AccountCanHaveMoreConnectedTrialAccountsDocument, options);
      }
export function useAccountCanHaveMoreConnectedTrialAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountCanHaveMoreConnectedTrialAccountsQuery, AccountCanHaveMoreConnectedTrialAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountCanHaveMoreConnectedTrialAccountsQuery, AccountCanHaveMoreConnectedTrialAccountsQueryVariables>(AccountCanHaveMoreConnectedTrialAccountsDocument, options);
        }
export function useAccountCanHaveMoreConnectedTrialAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountCanHaveMoreConnectedTrialAccountsQuery, AccountCanHaveMoreConnectedTrialAccountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountCanHaveMoreConnectedTrialAccountsQuery, AccountCanHaveMoreConnectedTrialAccountsQueryVariables>(AccountCanHaveMoreConnectedTrialAccountsDocument, options);
        }
export type AccountCanHaveMoreConnectedTrialAccountsQueryHookResult = ReturnType<typeof useAccountCanHaveMoreConnectedTrialAccountsQuery>;
export type AccountCanHaveMoreConnectedTrialAccountsLazyQueryHookResult = ReturnType<typeof useAccountCanHaveMoreConnectedTrialAccountsLazyQuery>;
export type AccountCanHaveMoreConnectedTrialAccountsSuspenseQueryHookResult = ReturnType<typeof useAccountCanHaveMoreConnectedTrialAccountsSuspenseQuery>;
export type AccountCanHaveMoreConnectedTrialAccountsQueryResult = Apollo.QueryResult<AccountCanHaveMoreConnectedTrialAccountsQuery, AccountCanHaveMoreConnectedTrialAccountsQueryVariables>;